import { DQF_ITEMS } from '@/components/admin/DQFChecklist';

// A driver's DQF file is "fully completed" once every non-optional
// checklist item is checked -- not just the two items flagged
// `required` in DQF_ITEMS (those gate a narrower set of hard
// compliance blockers elsewhere; this is the broader "can we actually
// put this person behind the wheel" bar for booking a load).
export function isDqfComplete(driver) {
  return DQF_ITEMS.filter(i => !i.optional).every(i => driver?.[i.key]);
}

// Equipment: at least one active truck (Asset) must be assigned to
// this driver's email. Trailer isn't required here -- many loads are
// power-only or use a shipper/customer-owned trailer, so it's not a
// hard blocker the same way having no truck at all is.
export function hasEquipmentAssigned(driverEmail, assets) {
  return (assets || []).some(a =>
    a.asset_type === 'Truck' &&
    a.is_active !== false &&
    a.assigned_driver_email?.toLowerCase() === (driverEmail || '').toLowerCase()
  );
}

// Returns { eligible, reasons } -- reasons is a list of human-readable
// blockers to surface to whoever's trying to book (dispatcher or the
// driver self-booking from the Load Board). Empty reasons = eligible.
export function checkBookingEligibility(driver, driverEmail, assets) {
  const reasons = [];
  if (!hasEquipmentAssigned(driverEmail, assets)) {
    reasons.push('No truck is assigned to this driver in Assets.');
  }
  if (!driver || !isDqfComplete(driver)) {
    reasons.push("This driver's DQF (Driver Qualification File) isn't fully completed.");
  }
  return { eligible: reasons.length === 0, reasons };
}
